import styles from './index.module.scss';
import Image from 'next/image';
import { FC } from 'react';

interface DownloadsProps {
  isLanding?: boolean;
  lang?: string;
}

const getPlatforms = (lang: string, isLanding: boolean) => {
  const basePlatforms = [
    {
      name: 'google play',
      baseName: 'google-play',
      fullImage: 'images/downloadPlatforms/google-play-en.svg',
      miniIcon: 'images/downloadPlatforms/icons/googlePlay.svg',
      link: 'https://play.google.com/store/apps/details?id=com.arbigroup.hr',
    },
    {
      name: 'app store',
      baseName: 'app-store',
      fullImage: 'images/downloadPlatforms/app-store-en.svg',
      miniIcon: 'images/downloadPlatforms/icons/apple.svg',
      link: '',
    },
    {
      name: 'RUstore',
      baseName: 'ru-store',
      fullImage: 'images/downloadPlatforms/ru-store.svg',
      miniIcon: 'images/downloadPlatforms/icons/ruStore.svg',
      link: 'https://www.rustore.ru/catalog/app/com.arbigroup.hr',
      locales: ['ru'],
    },
    {
      name: 'GetApps',
      baseName: 'get-apps',
      fullImage: 'images/downloadPlatforms/get-apps-en.svg',
      miniIcon: 'images/downloadPlatforms/icons/getApps.svg',
      link: 'https://global.app.mi.com/details?lo=RU&la=en_US&id=com.arbigroup.hr',
    },
    {
      name: 'App Gallery',
      baseName: 'app-gallery',
      fullImage: 'images/downloadPlatforms/app-gallery-en.svg',
      miniIcon: 'images/downloadPlatforms/icons/appGallery.svg',
      link: 'https://appgallery.huawei.com/#/app/C113663347',
    },
  ];

  const getPlatformImage = (baseName: string, fullImage: string) => {
    const localizedPath = `images/downloadPlatforms/${baseName}-${lang}.svg`;
    return lang === 'ru' || lang === 'en' ? localizedPath : fullImage;
  };

  return basePlatforms
    .filter((platform) => !platform.locales || platform.locales.includes(lang))
    .map((platform) => ({
      ...platform,
      image: isLanding
        ? getPlatformImage(platform.baseName, platform.fullImage)
        : platform.miniIcon,
      width: isLanding ? 294 : 44,
      height: isLanding ? 98 : 44,
    }));
};

const AppDownloads: FC<DownloadsProps> = ({ lang = 'en', isLanding = true }) => {
  const platforms = getPlatforms(lang, isLanding);

  return (
    <div className={isLanding ? styles.landingButtons : styles.footerButtons}>
      {platforms.map((platform) => (
        <a key={platform.name} href={platform.link} target='_blank' rel='noopener noreferrer'>
          <Image
            src={platform.image}
            width={platform.width}
            height={platform.height}
            alt={platform.name}
          />
        </a>
      ))}
    </div>
  );
};

export default AppDownloads;
